export const configData =  {  
    // APP_URL: "http://localhost/pos/web/",
    // APP_URL: "https://pos.aspiremax.in/api/web/",
    APP_URL: "/api/web/",
}